export const CHANNEL_CAT_HIDDEN = 'CHANNEL_CAT_HIDDEN'
export const CHANNEL_CAT_MOBILITY = 'CHANNEL_CAT_MOBILITY'
export const CHANNEL_CAT_INTERNAL = 'CHANNEL_CAT_INTERNAL'
export const CHANNEL_CAT_REGIONAL = 'CHANNEL_CAT_REGIONAL'
export const CHANNEL_CAT_EXTERNAL = 'CHANNEL_CAT_EXTERNAL'
export const CHANNEL_CAT_ADVERTISING = 'CHANNEL_CAT_ADVERTISING'
export const CHANNEL_CAT_JOBMARKETING = 'CHANNEL_CAT_JOBMARKETING'
